import { render } from "./SalaryReportPage.vue?vue&type=template&id=a045169c"
import script from "./SalaryReportPage.vue?vue&type=script&lang=js"
export * from "./SalaryReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__